export const onRevisionUpdated = (data, get) => {
  get().addRevisionAssignment(data.revision);
};
